// extracted by mini-css-extract-plugin
export default {"header":"modal_header__PwjEM","title":"modal_title__XZA9e","close":"modal_close__Xh-ru"};